import {createRouter, createWebHistory} from 'vue-router';
import Baiyin from "@/components/BaiYin.vue";
import TestPage from "@/components/TestPage.vue";
import fundPage from "@/components/fundPage.vue";
// import App from "@/App.vue";

const routes = [
    {
        path: '/',
        component: fundPage,
    },
    // {
    //     path: '/config-management',
    //     name: 'ConfigManagement',
    //     component: ConfigManagement,
    // },
    {
        path: '/baiyin',
        name: 'Baiyin',
        component: Baiyin,
    },
    {
        path: '/test',
        component: TestPage,
    },
    {
        path: '/fundPage',
        component: fundPage,
    },
    // {
    //     path: '/fund2',
    //     name: 'fund2',
    //     component: fundT2,
    // },

    // 可以添加更多路由规则
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;